import { render } from "./organization-list.vue?vue&type=template&id=64b09f9a&scoped=true&ts=true"
import script from "./organization-list.vue?vue&type=script&lang=ts"
export * from "./organization-list.vue?vue&type=script&lang=ts"

import "./organization-list.vue?vue&type=style&index=0&id=64b09f9a&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b09f9a"]])

export default __exports__